import styled from "styled-components";

export default styled.h2`
  text-align: left;
  font-size: 22px;
  /* font-weight: bold; */
  display: flex;
`;
